<div *ngIf="brandService.brand?.brandCardURL && imgSrc" class="brand-card">
  <a [href]="brandService.brand?.brandCardURL" target="_blank">
    <img [alt]="'brand card'" [src]="imgSrc" />
  </a>
</div>
